import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const PluginPrivacyAndComplianceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PluginPrivacyAndCompliance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apiKey"}},{"kind":"Field","name":{"kind":"Name","value":"compliance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storesPersonalData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"privacyUrl"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"PluginPrivacyAndCompliance","document":PluginPrivacyAndComplianceDocument}} as const;
export type PluginPrivacyAndComplianceQueryVariables = Types.Exact<{
  idPlugin: Types.Scalars['ID']['input'];
}>;


export type PluginPrivacyAndComplianceQuery = (
  { __typename: 'Query' }
  & { plugin?: Types.Maybe<(
    { __typename: 'Plugin' }
    & Pick<Types.Plugin, 'id' | 'apiKey' | 'privacyUrl'>
    & { compliance?: Types.Maybe<(
      { __typename: 'Plugin_Compliance' }
      & Pick<Types.Plugin_Compliance, 'storesPersonalData'>
    )> }
  )> }
);

/**
 * __usePluginPrivacyAndComplianceQuery__
 *
 * To run a query within a React component, call `usePluginPrivacyAndComplianceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePluginPrivacyAndComplianceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePluginPrivacyAndComplianceQuery({
 *   variables: {
 *      idPlugin: // value for 'idPlugin'
 *   },
 * });
 */
export function usePluginPrivacyAndComplianceQuery(
  baseOptions: TrelloQueryHookOptions<
    PluginPrivacyAndComplianceQuery,
    PluginPrivacyAndComplianceQueryVariables
  > &
    (
      | { variables: PluginPrivacyAndComplianceQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: PluginPrivacyAndComplianceDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    PluginPrivacyAndComplianceQuery,
    PluginPrivacyAndComplianceQueryVariables
  >(PluginPrivacyAndComplianceDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function usePluginPrivacyAndComplianceLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    PluginPrivacyAndComplianceQuery,
    PluginPrivacyAndComplianceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PluginPrivacyAndComplianceQuery,
    PluginPrivacyAndComplianceQueryVariables
  >(PluginPrivacyAndComplianceDocument, options);
}
export function usePluginPrivacyAndComplianceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        PluginPrivacyAndComplianceQuery,
        PluginPrivacyAndComplianceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PluginPrivacyAndComplianceQuery,
    PluginPrivacyAndComplianceQueryVariables
  >(PluginPrivacyAndComplianceDocument, options);
}
export type PluginPrivacyAndComplianceQueryHookResult = ReturnType<
  typeof usePluginPrivacyAndComplianceQuery
>;
export type PluginPrivacyAndComplianceLazyQueryHookResult = ReturnType<
  typeof usePluginPrivacyAndComplianceLazyQuery
>;
export type PluginPrivacyAndComplianceSuspenseQueryHookResult = ReturnType<
  typeof usePluginPrivacyAndComplianceSuspenseQuery
>;
export type PluginPrivacyAndComplianceQueryResult = Apollo.QueryResult<
  PluginPrivacyAndComplianceQuery,
  PluginPrivacyAndComplianceQueryVariables
>;
